import React, { useEffect, useState } from "react";
import { Form, Row, Col, Button } from "react-bootstrap";
import "../styles/TaskFilter.css";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const getYearOptions = () => {
  const currentYear = new Date().getFullYear();
  return Array.from({ length: 10 }, (_, i) => (currentYear - i).toString());
};

interface HolidayFilterProps {
  selectedYear: string;
  onYearChange: (year: string) => void;
  onFind: () => void;
  onReset: () => void;
}

const HolidayFilter: React.FC<HolidayFilterProps> = ({
  selectedYear,
  onYearChange,
  onFind,
  onReset,
}) => {
  const [yearOptions, setYearOptions] = useState<string[]>([]);
  const [showCustomInput, setShowCustomInput] = useState(false);
  const [customYear, setCustomYear] = useState("");

  useEffect(() => {
    setYearOptions(getYearOptions());
  }, []);

  const handleDropdownChange = (value: string) => {
    if (value === "other") {
      setShowCustomInput(true);
      setCustomYear(""); // reset custom input
      onYearChange(""); // clear selected year
    } else {
      setShowCustomInput(false);
      setCustomYear("");
      onYearChange(value);
    }
  };

  const handleFindClick = () => {
    const yearToValidate = showCustomInput ? customYear : selectedYear;

    if (!yearToValidate) {
      toast.warning("Please select or enter a year.");
      return;
    }

    onYearChange(yearToValidate); // ensure the final year is passed
    onFind();
  };

  return (
    <Form className="holiday-filter-form">
      <ToastContainer />
      <Row className="g-2 align-items-end">
        <Form.Group as={Col} xs={6} sm={4} md={3} controlId="year">
          <div className="dropdown-label">Year</div>
          {!showCustomInput ? (
            <Form.Select
              value={selectedYear}
              onChange={(e) => handleDropdownChange(e.target.value)}
              className="custom-select"
            >
              <option value="">Select Year</option>
              {yearOptions.map((year) => (
                <option key={year} value={year}>
                  {year}
                </option>
              ))}
              <option value="other">Other</option>
            </Form.Select>
          ) : (
            <Form.Control
              type="number"
              placeholder="Enter custom year"
              value={customYear}
              onChange={(e) => setCustomYear(e.target.value)}
            />
          )}
        </Form.Group>

        <Col xs={12} className="d-flex justify-content-end">
          <Button variant="primary" onClick={handleFindClick} className="m-1">
            Find
          </Button>
          <Button
            variant="secondary"
            onClick={() => {
              setShowCustomInput(false);
              setCustomYear("");
              onReset();
            }}
            className="m-1"
          >
            Reset
          </Button>
        </Col>
      </Row>
    </Form>
  );
};

export default HolidayFilter;
